import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.formbox');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-formbox',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.formbox/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.formbox-page {
  position: relative;
  isolation: isolate;
  min-height: 100svh;
  overflow: hidden;
  background: #fafafa;
}

.formbox-glow {
  position: absolute;
  z-index: -2;
  top: -330px;
  right: -210px;
  width: 760px;
  height: 760px;
  border-radius: 9999px;
  background: radial-gradient(circle, rgba(129, 140, 248, 0.2) 0%, rgba(165, 180, 252, 0.07) 45%, transparent 70%);
  pointer-events: none;
}

.formbox-dots {
  position: absolute;
  z-index: -1;
  inset: 0;
  opacity: 0.42;
  background-image: radial-gradient(rgba(100, 116, 139, 0.17) 1px, transparent 1px);
  background-size: 22px 22px;
  mask-image: linear-gradient(110deg, black, transparent 75%);
  -webkit-mask-image: linear-gradient(110deg, black, transparent 75%);
  pointer-events: none;
}

.formbox-mark {
  display: flex;
  width: 40px;
  height: 40px;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(99, 102, 241, 0.2);
  border-radius: 13px;
  background: rgba(238, 242, 255, 0.9);
  box-shadow: 0 8px 28px rgba(99, 102, 241, 0.08);
}

.formbox-mark span {
  display: block;
  height: 3px;
  border-radius: 9999px;
  background: #6366f1;
}

.formbox-mark span:nth-child(1) {
  width: 17px;
}

.formbox-mark span:nth-child(2) {
  width: 13px;
}

.formbox-mark span:nth-child(3) {
  width: 17px;
}

.progress-dot {
  width: 7px;
  height: 7px;
  border-radius: 9999px;
  background: #6366f1;
  box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.28);
  animation: progress-pulse 2.2s ease-out infinite;
}

.form-stage {
  padding: 28px 18px;
  perspective: 1000px;
}

.form-stage::before {
  content: "";
  position: absolute;
  inset: 16% 5% 8%;
  z-index: -1;
  border-radius: 40px;
  background: rgba(99, 102, 241, 0.08);
  filter: blur(34px);
}

.form-sheet {
  position: relative;
  min-height: 400px;
  padding: 32px;
  border: 1px solid rgba(226, 232, 240, 0.96);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 32px 90px rgba(30, 41, 59, 0.11), inset 0 1px 0 rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(18px);
  transform: rotateY(-3deg) rotateX(1deg);
}

.submit-placeholder {
  width: 92px;
  height: 38px;
  border-radius: 11px;
  background: linear-gradient(135deg, #6366f1, #818cf8);
  box-shadow: 0 9px 22px rgba(99, 102, 241, 0.24);
}

.floating-box {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  color: #4f46e5;
  border: 1px solid rgba(199, 210, 254, 0.9);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 16px 40px rgba(30, 41, 59, 0.12);
  backdrop-filter: blur(12px);
  animation: box-float 4.5s ease-in-out infinite;
}

.box-one {
  top: 5px;
  right: -2px;
  width: 48px;
  height: 48px;
  border-radius: 15px;
}

.box-two {
  bottom: 8px;
  left: -8px;
  width: 74px;
  height: 48px;
  gap: 5px;
  border-radius: 15px;
  animation-delay: -2s;
}

.box-two span {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #818cf8;
}

.box-two span:nth-child(2) {
  background: #a5b4fc;
}

@keyframes progress-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.3);
  }
  70% {
    box-shadow: 0 0 0 9px rgba(99, 102, 241, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(99, 102, 241, 0);
  }
}
@keyframes box-float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}
@media (max-width: 640px) {
  .form-sheet {
    padding: 25px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .progress-dot,
  .floating-box {
    animation: none;
  }
}`],
})
export class PageFormboxComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public navigateHome(event?: MouseEvent) {
        if (!event || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();
        this.service.href('/');
    }
}

export default PageFormboxComponent;